import { useAuth } from '../../../use';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const auth = useAuth();
const actions = new Actions('interview', 'interviews');

const customActions = {
  async LOAD_interviews({ commit, rootGetters }) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('interviews')
      .query({ $filter: 'IsDeleted eq false', $expand: 'SkillSet' });
    commit('SET_interviews', data);
    return data;
  },
};

export default { ...actions, ...customActions };
